import { CalendarCheck2, ListChecks, FolderCheck, MessagesSquare, UserRound, LayoutGrid } from "lucide-react";

const ITEMS = [
  { icon: CalendarCheck2, text: "Scadenze più chiare" },
  { icon: ListChecks, text: "Adempimenti sotto controllo" },
  { icon: FolderCheck, text: "Documenti organizzati" },
  { icon: MessagesSquare, text: "Comunicazione diretta col professionista" },
  { icon: UserRound, text: "Professionisti interni" },
  { icon: LayoutGrid, text: "Un unico spazio digitale" },
];

export default function Marquee() {
  return (
    <div
      data-testid="marquee-ticker"
      className="marquee-hover relative overflow-hidden border-y border-white/10 bg-slate-950/60 py-5"
      aria-label="Servizi Human Factor"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-[#0B132B] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-[#0B132B] to-transparent" />
      <div className="flex w-max animate-marquee items-center gap-10 pr-10">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex items-center gap-10">
            {ITEMS.map(({ icon: Icon, text }) => (
              <span key={`${copy}-${text}`} className="flex items-center gap-3 whitespace-nowrap">
                <span className="flex h-8 w-8 items-center justify-center rounded-full border border-cyan-400/25 bg-cyan-400/10 text-cyan-300">
                  <Icon className="h-3.5 w-3.5" />
                </span>
                <span className="font-display text-sm font-semibold uppercase tracking-[0.14em] text-slate-300">
                  {text}
                </span>
                <span className="ml-6 h-1.5 w-1.5 rounded-full bg-[#19D6E8]/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
